<template>
  <div id="andon-buttom">
    <dv-border-box-4>
      <table id="tableButtom" style="width: 100%">
        <tr>
          <td>
            <dv-decoration-11 style="width: 200px; height: 60px; color: white"
              >年计划</dv-decoration-11
            >
          </td>
          <td>
            <dv-digital-flop
              :config="year_Planconfig"
              style="width: 100%; height: 50px"
            />
          </td>
          <td>
            <dv-decoration-11 style="width: 200px; height: 60px; color: white"
              >月计划</dv-decoration-11
            >
          </td>
          <td>
            <dv-digital-flop
              :config="month_Planconfig"
              style="width: 100%; height: 50px"
            />
          </td>
          <td>
            <dv-decoration-11 style="width: 200px; height: 60px; color: white"
              >日计划</dv-decoration-11
            >
          </td>
          <td>
            <dv-digital-flop
              :config="day_Planconfig"
              style="width: 100%; height: 50px"
            />
          </td>
          <td>
            <dv-decoration-11 style="width: 200px; height: 60px; color: white"
              >上线机型</dv-decoration-11
            >
          </td>
          <td>
            <dv-digital-flop
              :config="on_LineEngineTypeconfig"
              style="width: 100%; height: 50px"
            />
          </td>
        </tr>
        <tr>
          <td>
            <dv-decoration-11 style="width: 200px; height: 60px; color: white"
              >年完成</dv-decoration-11
            >
          </td>
          <td>
            <dv-digital-flop
              :config="year_Compelteconfig"
              style="width: 100%; height: 50px"
            />
          </td>
          <td>
            <dv-decoration-11 style="width: 200px; height: 60px; color: white"
              >月完成</dv-decoration-11
            >
          </td>
          <td>
            <dv-digital-flop
              :config="month_Compelteconfig"
              style="width: 100%; height: 50px"
            />
          </td>
          <td>
            <dv-decoration-11 style="width: 200px; height: 60px; color: white"
              >日完成</dv-decoration-11
            >
          </td>
          <td>
            <dv-digital-flop
              :config="day_Compelteconfig"
              style="width: 100%; height: 50px"
            />
          </td>
          <td>
            <dv-decoration-11 style="width: 200px; height: 60px; color: white"
              >下线机型</dv-decoration-11
            >
          </td>
          <td>
            <dv-digital-flop
              :config="down_LineEngineTypeconfig"
              style="width: 100%; height: 50px"
            />
          </td>
        </tr>
      </table>
    </dv-border-box-4>
  </div>
</template>

<script>
export default {
  name: "AndonButtom",

  methods: {
    me_yearCompelteconfig(yeardata) {
      this.year_Compelteconfig.number = [yeardata];
      this.year_Compelteconfig = { ...this.year_Compelteconfig };
    },
    me_MonthCompelteconfig(monthdata) {
      this.month_Compelteconfig.number = [monthdata];
      this.month_Compelteconfig = { ...this.month_Compelteconfig };
    },
    me_DayCompelteconfig(daydata) {
      this.day_Compelteconfig.number = [daydata];
      this.day_Compelteconfig = { ...this.day_Compelteconfig };
    },
    me_yearPlanconfig(yeardata) {
      this.year_Planconfig.number = [yeardata];
      this.year_Planconfig = { ...this.year_Planconfig };
    },
    me_MonthPlanconfig(monthdata) {
      this.month_Planconfig.number = [monthdata];
      this.month_Planconfig = { ...this.month_Planconfig };
    },
    me_DayPlanconfig(daydata) {
      this.day_Planconfig.number = [daydata];
      this.day_Planconfig = { ...this.day_Planconfig };
    },

    me_downLineEngineTypeconfig(downLineEngineType) {
      this.down_LineEngineTypeconfig.content = downLineEngineType;
      this.down_LineEngineTypeconfig = { ...this.down_LineEngineTypeconfig };
    },
    me_OnEngineTypeconfig(onlineType) {
      this.on_LineEngineTypeconfig.content = onlineType;
      this.on_LineEngineTypeconfig = { ...this.on_LineEngineTypeconfig };
    },
  },
  data() {
    return {
      year_Compelteconfig: {
        number: [88888],
        content: "{nt}台",
      },
      month_Compelteconfig: {
        number: [8888],
        content: "{nt}台",
      },
      day_Compelteconfig: {
        number: [8888],
        content: "{nt}台",
      },
      year_Planconfig: {
        number: [88888],
        content: "{nt}台",
      },
      month_Planconfig: {
        number: [8888],
        content: "{nt}台",
      },
      day_Planconfig: {
        number: [8888],
        content: "{nt}台",
      },
      down_LineEngineTypeconfig: {
        content: "EC88",
      },
      on_LineEngineTypeconfig: {
        content: "EC88",
      },
      flopconfig: {
        number: [88],
        content: "{nt}台",
      },
      flopTextconfig: {
        content: "ED96",
      },
    };
  },
};
</script>
<style lang="less">
#v-border-box-4 {
  height: 100%;
}
#andon-buttom {
  height: 25%;
}
#tableButtom {
  padding: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/AndonButtom.vue